// 组件对象，大写
import hoverPoptip from './hoverPoptip.vue'
export default hoverPoptip
